import { z } from "zod"
import { ArrowRight, Lock, Mail, User } from "lucide-react"

import { Button } from "@/components/ui/button"
import { Form } from "@/components/ui/form"
import { IconInputField } from "@/components/auth/IconInputField"
import { useAuthForm } from "@/lib/use-auth-form"
import { emailSchema, passwordComplexitySchema } from "@/lib/auth-schemas"

const schema = z
  .object({
    first_name: z.string().min(1, "Required"),
    last_name: z.string().min(1, "Required"),
    email: emailSchema,
    password: passwordComplexitySchema,
    password_confirmation: z.string(),
  })
  .refine((data) => data.password === data.password_confirmation, {
    message: "Passwords must match",
    path: ["password_confirmation"],
  })

const DEFAULT_VALUES = {
  first_name: "",
  last_name: "",
  email: "",
  password: "",
  password_confirmation: "",
}

export function SignupForm({ onSubmit }) {
  const { form, serverError, submit } = useAuthForm({
    schema,
    defaultValues: DEFAULT_VALUES,
    onSubmit,
  })

  return (
    <Form {...form}>
      <form onSubmit={submit} className="space-y-5" noValidate autoComplete="off">
        <div className="grid grid-cols-2 gap-4">
          <IconInputField
            form={form}
            name="first_name"
            label="First Name"
            icon={User}
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="words"
            spellCheck={false}
            placeholder="John"
          />
          <IconInputField
            form={form}
            name="last_name"
            label="Last Name"
            icon={User}
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="words"
            spellCheck={false}
            placeholder="Doe"
          />
        </div>

        <IconInputField
          form={form}
          name="email"
          label="Email Address"
          icon={Mail}
          type="email"
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          spellCheck={false}
          placeholder="operator@sentinel.os"
        />

        <IconInputField
          form={form}
          name="password"
          label="Password"
          icon={Lock}
          type="password"
          autoComplete="new-password"
          placeholder="••••••••"
        />

        <IconInputField
          form={form}
          name="password_confirmation"
          label="Confirm Password"
          icon={Lock}
          type="password"
          autoComplete="new-password"
          placeholder="••••••••"
        />

        {serverError ? (
          <p role="alert" className="text-sm font-medium text-destructive">
            {serverError}
          </p>
        ) : null}

        <Button
          type="submit"
          disabled={form.formState.isSubmitting}
          className="mt-4 h-12 w-full gap-2 rounded-xl text-sm font-bold shadow-md shadow-primary/20"
        >
          Create Operator Profile
          <ArrowRight className="h-4 w-4" />
        </Button>
      </form>
    </Form>
  )
}
